import { Factory, Ruler, BadgeCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const ICONS = [Factory, Ruler, BadgeCheck];

const FEATURES = [
  {
    num: "01",
    title: "In-House Manufacturing",
    body: "Every tray is punched, bent and deburred at our own Ranipur unit — precision perforation patterns, consistent quality, no outsourced shortcuts.",
    testid: "chapter-01",
  },
  {
    num: "02",
    title: "Custom Fabrication",
    body: "From a single 3-metre length to full project schedules, we fabricate to your drawings — custom widths, custom heights, custom finishes.",
    testid: "chapter-02",
  },
  {
    num: "03",
    title: "Certified Steel",
    body: "HR, CR and galvanized steel in 1.2 to 2.5 mm gauges, finished pre-galvanized, hot-dip or powder coated. Material test certificates with every dispatch lot.",
    testid: "chapter-03",
  },
];

export const Manifesto = () => {
  return (
    <section id="why" data-testid="manifesto-section" className="relative bg-ink py-20 md:py-28 border-t border-white/10">
      <div className="max-w-[1440px] mx-auto px-5 md:px-10">
        <Reveal>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div>
              <p className="font-mono text-[10px] md:text-xs tracking-[0.35em] uppercase text-smoke mb-4">
                About D V Steels
              </p>
              <h2 className="font-heading font-semibold uppercase text-3xl md:text-5xl tracking-wide text-white leading-tight">
                Built for today.
                <br />
                Ready for tomorrow.
              </h2>
              <p className="mt-6 font-body text-sm md:text-base text-smoke leading-relaxed max-w-xl">
                D V Steels is a cable tray manufacturing unit based in the Industrial
                Growth area of Ranipur, Pathankot. We supply perforated cable trays,
                ladder trays and matching accessories to contractors, panel builders
                and industrial projects across Punjab and North India.
              </p>
              <p className="mt-5 font-body text-sm md:text-base text-white/80 leading-relaxed max-w-xl border-l-2 border-[#7FB3E8] pl-4">
                "We don't sell trays. We sell the certainty that your cabling outlives
                the building."
              </p>
              <p className="mt-2 font-mono text-[10px] tracking-[0.3em] uppercase text-white/50 pl-4">
                — Founding principle, D V Steels
              </p>
            </div>
            <div>
              <div className="clip-br bg-white p-4 md:p-6 shadow-[0_24px_50px_rgba(0,0,0,0.4)]">
                <img
                  src="/assets/tray-perforated.png"
                  alt="Perforated cable trays manufactured by D V Steels"
                  className="w-full h-auto object-contain"
                />
              </div>
              <p className="mt-3 font-mono text-[10px] tracking-[0.25em] uppercase text-smoke text-right">
                Perforated cable trays — our core product
              </p>
            </div>
          </div>
        </Reveal>

        <div className="mt-14 md:mt-20 grid grid-cols-1 md:grid-cols-3 gap-5">
          {FEATURES.map((f, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={f.num} delay={i * 0.08}>
                <div
                  data-testid={f.testid}
                  className="group h-full bg-steel border border-white/10 p-7 hover:border-[#7FB3E8]/40 transition-colors duration-300"
                >
                  <div className="flex items-center justify-between">
                    <p className="font-mono text-xs text-smoke">{f.num}</p>
                    <span className="p-2 bg-royal/60 text-[#7FB3E8] group-hover:bg-royal transition-colors duration-300">
                      <Icon size={18} />
                    </span>
                  </div>
                  <h3 className="mt-3 font-heading font-semibold uppercase text-2xl tracking-wide text-white">
                    {f.title}
                  </h3>
                  <p className="mt-3 font-body text-sm text-smoke leading-relaxed">{f.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
